const semanticClassNames = {
  root: 'productSpecification',
} as const;

export default semanticClassNames;
